module.exports = __webpack_public_path__ + "img/icone-org-config.2a8fdd9f.svg";